import Model from '@tripian/model';

interface IUserState {
  // Auths
  isLoggedIn: boolean;

  // User Data
  user?: Model.User;
  tripReferences?: Model.TripReference[];
  companions?: Model.Companion[];

  // Loadings
  loading: { user: boolean; tripReferences: boolean; companions: boolean };

  // Errors
  errors: { id: number; functionName: string; title: string; message: string; hide: boolean }[];
}

export default IUserState;

export const initialUserState: IUserState = {
  // Auths
  isLoggedIn: false,

  // User Data
  user: undefined,
  tripReferences: undefined,
  companions: undefined,

  // Loadings
  loading: { user: true, tripReferences: true, companions: true },

  // Errors
  errors: [],
};
